import { render, staticRenderFns } from "./Burned.vue?vue&type=template&id=2a9293c0&scoped=true&lang=pug"
import script from "./Burned.vue?vue&type=script&lang=js"
export * from "./Burned.vue?vue&type=script&lang=js"
import style0 from "./Burned.vue?vue&type=style&index=0&id=2a9293c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9293c0",
  null
  
)

export default component.exports